// extracted by mini-css-extract-plugin
module.exports = {"vehicleResult":"license-plate-step_vehicleResult_1GqTr"};